import HTTPServices from 'services/https';
import {
  FETCH_LANGUAGES_REQUEST,
  FETCH_LANGUAGES_SUCCESS,
  FETCH_LANGUAGES_FAILURE
} from './types';

export const fetchLanguagesRequest = () => {
  return {
    type: FETCH_LANGUAGES_REQUEST
  };
};

export const fetchLanguagesSuccess = (languages) => {
  return {
    type: FETCH_LANGUAGES_SUCCESS,
    payload: languages
  };
};

export const fetchLanguagesFailure = (error) => {
  return {
    type: FETCH_LANGUAGES_FAILURE,
    payload: error
  };
};

// Thunk action creator
export const fetchLanguages = (query = '', sortBy = 'name', sortDir = 'asc') => {
  return (dispatch) => {
    dispatch(fetchLanguagesRequest());
    HTTPServices.get(`/languages?q=${query}&sort_by=${sortBy}&sort_dir=${sortDir}`)
      .then(response => {
        dispatch(fetchLanguagesSuccess(response.data));
      })
      .catch(error => {
        dispatch(fetchLanguagesFailure(error.message));
      });
  };
};